var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStampliLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 19,
    viewBox: "0 0 32 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1021_74091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9746 3.30005C28.4843 3.42006 28.9341 3.54006 29.3838 3.66006L30.913 4.08008L32.0224 0.779951C31.0629 0.47994 30.0735 0.209928 29.114 -0.0300817L27.9746 3.30005Z",
    fill: "url(#paint0_linear_1021_74091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8136 8.81999C10.9141 8.81999 10.1646 9.57002 10.1646 10.4701C10.1646 11.3701 10.9141 12.1201 11.8136 12.1201C12.7132 12.1201 13.4627 11.3701 13.4627 10.4701C13.4927 9.54002 12.7431 8.81999 11.8136 8.81999Z",
    fill: "url(#paint1_linear_1021_74091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4399 10.4701C18.4399 11.3701 19.1895 12.1201 20.089 12.1201C20.9885 12.1201 21.7381 11.3701 21.7381 10.4701C21.7381 9.54002 20.9885 8.81999 20.089 8.81999C19.1595 8.81999 18.4399 9.54002 18.4399 10.4701Z",
    fill: "url(#paint2_linear_1021_74091)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1.19989L4.58749 14.6104L4.64746 14.7604C4.73741 14.9704 5.72687 16.9805 8.33544 17.5205C9.89459 17.8505 13.0729 18.0005 15.4416 18.0605H15.9513L16.491 18.0305C18.8297 17.9705 21.978 17.7905 23.5671 17.4905C26.1457 16.9505 27.1352 15.0004 27.2551 14.7304L30.4034 5.46005L28.8442 5.04004C23.4472 3.56998 18.3799 3.29997 16.461 3.23997C16.2511 3.23997 16.1012 3.23997 15.9213 3.23997C15.7714 3.23997 15.6215 3.23997 15.4116 3.23997H15.0218C10.884 3.23997 5.90677 4.41001 5.90677 4.41001L6.89623 7.29013C6.89623 7.29013 12.0834 6.24009 14.9918 6.24009L15.8913 6.21008H16.371C17.8702 6.24008 21.7981 6.4501 26.1757 7.44013L26.4455 7.50014L24.4067 13.4704C24.2567 13.7104 23.807 14.2804 22.8775 14.4904C21.8281 14.7004 19.4294 14.8804 16.2811 14.9704H15.8913H15.4416C12.3233 14.8804 9.92457 14.7004 8.87514 14.4904C7.91567 14.2804 7.46592 13.6804 7.34598 13.5004L7.316 13.4404L2.84844 0.329855C1.94893 0.629866 0.959475 0.899878 0 1.19989Z",
    fill: "url(#paint3_linear_1021_74091)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1021_74091",
    x1: -30.0546,
    y1: 37.2929,
    x2: 59.7093,
    y2: -15.3378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    stopColor: "#834B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC3882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1021_74091",
    x1: -31.0289,
    y1: 35.6308,
    x2: 58.735,
    y2: -16.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    stopColor: "#834B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC3882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1021_74091",
    x1: -28.9161,
    y1: 39.2357,
    x2: 60.8478,
    y2: -13.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    stopColor: "#834B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC3882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1021_74091",
    x1: -31.4459,
    y1: 34.9185,
    x2: 58.318,
    y2: -17.7122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.471,
    stopColor: "#834B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC3882"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1021_74091"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 18.1132,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStampliLogo);
export default __webpack_public_path__ + "static/media/StampliLogo.e00028025d38ba74b0dae7ff48198dbe.svg";
export { ForwardRef as ReactComponent };